import { FC, useMemo } from 'react';
import { RadixTable, TColumn } from '@features/ui';

type Row = {
  product?: string;
  system?: string;
  secondPeriod?: string;
  secondTotal?: string;
};

export const ChangeBillingTerms: FC = () => {
  // Mock realistic billing terms data
  const data: Row[] = useMemo(() => [], []);

  const columns: TColumn<Row>[] = useMemo(
    () => [
      { title: 'PRODUCT(S)', render: (r) => <span>{r?.product ?? ''}</span> },
      {
        title: 'PAYMENT SYSTEM',
        render: (r) => <span>{r?.system ?? ''}</span>,
      },
      {
        title: 'SECOND PERIOD',
        render: (r) => <span>{r?.secondPeriod ?? ''}</span>,
      },
      {
        title: 'SECOND TOTAL',
        render: (r) => <span>{r?.secondTotal ?? ''}</span>,
      },
    ],
    []
  );

  return <RadixTable columns={columns} data={data} />;
};
